import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/userAuth/UserAuthState";
import DashboardLayout from "../components/DashboardLayout";
import { BsPatchCheck, BsGear, BsArrowRight } from "react-icons/bs";
import { FaShieldAlt } from "react-icons/fa";

const DashboardPage = () => {
  const { user } = useAuth();
  const firstName = user?.user?.first_name || "Admin";

  return (
    <DashboardLayout pageTitle="Dashboard">

      {/* Welcome banner */}
      <div className="db-welcome">
        <div className="db-welcome__text">
          <h2 className="db-welcome__title">Welcome back, {firstName}</h2>
          <p className="db-welcome__sub">
            TUV PAK Inspec Management Portal — manage certifications and user cards from here.
          </p>
        </div>
        <div className="db-welcome__icon">
          <FaShieldAlt size={48} />
        </div>
      </div>

      {/* Quick action cards */}
      <div className="db-cards">

        <Link to="/all-certifications" className="db-card db-card--red">
          <div className="db-card__icon">
            <BsPatchCheck size={28} />
          </div>
          <div className="db-card__body">
            <h3 className="db-card__title">All Certifications</h3>
            <p className="db-card__desc">Create, search, edit and manage digital certification documents.</p>
          </div>
          <BsArrowRight className="db-card__arrow" size={20} />
        </Link>

        <Link to="/settings" className="db-card db-card--gray">
          <div className="db-card__icon">
            <BsGear size={28} />
          </div>
          <div className="db-card__body">
            <h3 className="db-card__title">Settings</h3>
            <p className="db-card__desc">Manage your account preferences and portal settings.</p>
          </div>
          <BsArrowRight className="db-card__arrow" size={20} />
        </Link>

      </div>

      {/* Info strip */}
      <div className="db-info">
        <div className="db-info__item">
          <span className="db-info__label">Company</span>
          <span className="db-info__value">TUV PAK Inspection Services</span>
        </div>
        <div className="db-info__divider" />
        <div className="db-info__item">
          <span className="db-info__label">Portal</span>
          <span className="db-info__value">Admin Management Dashboard</span>
        </div>
        <div className="db-info__divider" />
        <div className="db-info__item">
          <span className="db-info__label">Session</span>
          <span className="db-info__value">Expires after 24 hours</span>
        </div>
      </div>

    </DashboardLayout>
  );
};

export default DashboardPage;
